import { render, staticRenderFns } from "./form.vue?vue&type=template&id=c48ed792&"
import script from "./form.vue?vue&type=script&lang=js&"
export * from "./form.vue?vue&type=script&lang=js&"
import style0 from "./form.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/easy_dev/extranet/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c48ed792')) {
      api.createRecord('c48ed792', component.options)
    } else {
      api.reload('c48ed792', component.options)
    }
    module.hot.accept("./form.vue?vue&type=template&id=c48ed792&", function () {
      api.rerender('c48ed792', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/admin/permission/components/form.vue"
export default component.exports